import {
  assessments as AssessmentsServices,
  homeworks as HomeworksServices,
} from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { coursesTypes } from '../../reducers/types';

export const deleteAssessmentStart = () => ({
  type: coursesTypes.DELETE_ASSESSMENT_START,
});

export const deleteAssessmentEnd = () => ({
  type: coursesTypes.DELETE_ASSESSMENT_END,
});

const deleteAssessment = (isHomework, assessmentId) =>
  isHomework
    ? HomeworksServices.deleteHomework({ homeworkId: assessmentId })
    : AssessmentsServices.deleteAssessment({ assessmentId });

export default (
    { assessmentId, callback, isHomework } = { isHomework: false },
  ) =>
  async dispatch => {
    try {
      dispatch(deleteAssessmentStart());
      await deleteAssessment(isHomework, assessmentId);
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(deleteAssessmentEnd());
    }
  };
